export var TOGGLE_WP_UPDATE = 'TOGGLE_WP_UPDATE';
export var RESET_WP = 'RESET_WP';
export function toggleWidePreviewer(value, src) {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_WP_UPDATE,
            payload: { value: value, src: src }
        });
    };
}
export function clearWidePreviewer() {
    return function (dispatch) {
        dispatch({
            type: RESET_WP,
            payload: { value: false, src: null }
        });
    };
}
//# sourceMappingURL=toggleWidePreviewer.js.mapexport var TOGGLE_WP_UPDATE = 'TOGGLE_WP_UPDATE';
export var RESET_WP = 'RESET_WP';
export function toggleWidePreviewer(value, src) {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_WP_UPDATE,
            payload: { value: value, src: src }
        });
    };
}
export function clearWidePreviewer() {
    return function (dispatch) {
        dispatch({
            type: RESET_WP,
            payload: { value: false, src: null }
        });
    };
}
//# sourceMappingURL=toggleWidePreviewer.js.map